import { RowActionsColumn } from "src/components/tables/columnConfigs/actionsColumn";
import { BotActionsColumn } from "src/components/tables/columnConfigs/botActionsColumn";
import { DateColumn } from "src/components/tables/columnConfigs/dateColumn";
import { DetailWithtooltipColumn } from "src/components/tables/columnConfigs/detailWithtooltipColumn";
import { StatusColumn } from "src/components/tables/columnConfigs/statusColumn";
import { StringColumn } from "src/components/tables/columnConfigs/stringColumn";

/**
 * Column configuration for bot users table
 */
export const botTableColumns = {
  name: new StringColumn({
    label: "Name"
  }),
  bindings: new StringColumn({
    label: "Bindings"
  }),
  userStatus: new StatusColumn({
    label: "User status"
  }),
  createdAt: new DateColumn({
    label: "Added Date",
    hidden: true
  }),
  action: new BotActionsColumn({
    label: "Actions",
    sortable: false
  })
};

/**
 * Column configuration for bot bindings table
 */
export const bindingsTableColumns = {
  service: new StringColumn({
    label: "Service"
  }),
  botUser: new StringColumn({
    label: "Bot user"
  }),
  bindStatus: new StatusColumn({
    label: "Bind status"
  }),
  addedBy: new StringColumn({
    label: "Added by",
    hidden: true
  }),
  addedDate: new DateColumn({
    label: "Added Date",
    hidden: true
  }),
  serviceDetails: new DetailWithtooltipColumn({
    label: "Service details"
  }),
  action: new RowActionsColumn({
    label: "Actions",
    sortable: false
  })
};
